import { Workflow } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { SchemaSetupLink } from './SchemaSetupNotice'

interface SchemaSetupDialogProps {
  caseId: string
  open: boolean
  onDismiss: () => void
}

export function SchemaSetupDialog({ caseId, open, onDismiss }: SchemaSetupDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={next => !next && onDismiss()}>
      <DialogContent className="sm:max-w-md">
        <div className="flex size-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Workflow className="size-5" aria-hidden />
        </div>
        <DialogHeader>
          <DialogTitle>{t('cases.documents.schemaSetup.dialog.title')}</DialogTitle>
          <DialogDescription>
            {t('cases.documents.schemaSetup.dialog.description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t('cases.documents.schemaSetup.later')}</Button>
          </DialogClose>
          <SchemaSetupLink caseId={caseId} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
